import { appSetLoading } from "../store/actions/appAction";
import axios from "../axios/axios";
import { setNews } from "../store/actions/newsAction";


export const apiGetNews = (callback) => (dispatch) => {
  let url = `news/list`
  axios
    .get(url)
    .then((response) => {
      dispatch(setNews(response.data.news))
      //dispatch(appSetLoading(false))
      if(callback){
        callback()
      }
    })
    .catch((error) => {

    })
}